export function signOut() {
  sessionStorage.setItem("isUserAuthenticated", "false");
  sessionStorage.setItem('contact_id', '');    
  sessionStorage.setItem('user_id', '');
  sessionStorage.setItem("isImpersonating", "false");   
  sessionStorage.setItem("first_name", '');
  sessionStorage.setItem("full_name", '');    
}

export function signIn() {
  sessionStorage.setItem("isUserAuthenticated", "true");
  sessionStorage.setItem("isImpersonating", "false");
}

export function isLoggedIn() {
  return sessionStorage.getItem('isUserAuthenticated', 'false') === 'true';
}




// WEBPACK FOOTER //
// ./src/shared/auth.js